// App.js versi terbaru — versi komponen terpisah
import { useEffect, useState } from "react";
import "./App.css";
import Header from "./components/Header";
import TodoForm from "./components/TodoForm";
import TodoList from "./components/TodoList";
import Modal from "./components/Modal";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

function App() {
  const [task, setTask] = useState("");
  const [todos, setTodos] = useState([]);
  const [deadline, setDeadline] = useState("");
  const [filter, setFilter] = useState("all");
  const [theme, setTheme] = useState("dark");
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(null);

  const addTodo = () => {
    if (task.trim() === "") {
      setShowModal("Tugas harus diisi!");
      return;
    }
    const newTodo = {
      id: Date.now(),
      text: task,
      deadline,
      done: false,
    };
    const updatedTodos = [...todos, newTodo];
    setTodos(updatedTodos);
    localStorage.setItem("todos", JSON.stringify(updatedTodos));
    setTask("");
    setDeadline("");
  };

  const toggleDone = (id) => {
    setShowModal({ type: "done", id });
  };

  const confirmToggleDone = (id) => {
    const updated = todos.map((todo) =>
      todo.id === id ? { ...todo, done: !todo.done } : todo
    );
    setTodos(updated);
    localStorage.setItem("todos", JSON.stringify(updated));
    setShowModal(null);
  };

  const deleteTodo = (id) => {
    setShowModal({ type: "delete", id });
  };

  const editTodo = (id) => {
    const current = todos.find((t) => t.id === id);
    if (!current) return;

    setShowModal({
      type: "edit",
      id,
      text: current.text,
      deadline: current.deadline || "",
    });
  };

  const confirmDelete = (id) => {
    const updated = todos.filter((todo) => todo.id !== id);
    setTodos(updated);
    localStorage.setItem("todos", JSON.stringify(updated));
    setShowModal(null);
  };

  const confirmEdit = (payload) => {
    const { id, text, deadline: newDeadline } = payload;
    const trimmed = text.trim();
    if (!trimmed) return;

    const updated = todos.map((todo) =>
      todo.id === id ? { ...todo, text: trimmed, deadline: newDeadline } : todo
    );
    setTodos(updated);
    localStorage.setItem("todos", JSON.stringify(updated));
    setShowModal(null);
  };

  const clearAll = () => {
    setShowModal({ type: "clear" });
  };

  const confirmClearAll = () => {
    setTodos([]);
    localStorage.removeItem("todos");
    setShowModal(null);
  };

  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem("todos"));
    if (saved) setTodos(saved);
  }, []);

  const filteredTodos = todos.filter((todo) => {
    const matchesFilter =
      filter === "all" || (filter === "done" ? todo.done : !todo.done);
    const matchesSearch = todo.text
      .toLowerCase()
      .includes(search.toLowerCase());
    return matchesFilter && matchesSearch;
  });

  const formatDeadline = (dateStr) => {
    if (!dateStr) return "Tanpa deadline";
    const date = new Date(dateStr);
    if (Number.isNaN(date.getTime())) return "Tanpa deadline";

    const today = new Date();
    if (date.toDateString() === today.toDateString()) return "Hari ini";
    if (date < today) return "Lewat deadline";
    return date.toLocaleDateString("id-ID");
  };

  const getDeadlineColor = (dateStr, done) => {
    if (done) return "gray";
    if (!dateStr) return "#0bc5ea";
    const date = new Date(dateStr);
    if (Number.isNaN(date.getTime())) return "#0bc5ea";

    const today = new Date();
    if (date.toDateString() === today.toDateString()) return "#38b000";
    if (date < today) return "#f03e3e";
    return "#0bc5ea";
  };

  return (
    <div className={`app ${theme}`}>
      <Navbar
        theme={theme}
        onToggleTheme={() => setTheme(theme === "dark" ? "light" : "dark")}
      />

      <div className="app-inner">
        <Header />

        <div className="layout">
          <div className="layout-left">
            <TodoForm
              task={task}
              deadline={deadline}
              onTaskChange={setTask}
              onDeadlineChange={setDeadline}
              onSubmit={addTodo}
            />
          </div>

          <div className="layout-right">
            <TodoList
              todos={filteredTodos}
              filter={filter}
              search={search}
              onFilterChange={setFilter}
              onSearchChange={setSearch}
              onToggleDone={toggleDone}
              onDelete={deleteTodo}
              onEdit={editTodo}
              onClearAll={clearAll}
              formatDeadline={formatDeadline}
              getDeadlineColor={getDeadlineColor}
            />
          </div>
        </div>
      </div>

      <Modal
        showModal={showModal}
        todos={todos}
        onClose={() => setShowModal(null)}
        onConfirmToggle={confirmToggleDone}
        onConfirmDelete={confirmDelete}
        onConfirmClear={confirmClearAll}
        onConfirmEdit={confirmEdit}
      />

      <Footer />
    </div>
  );
}

export default App;
